import { Capacitor } from '@capacitor/core';
import { PrivyProvider } from '@privy-io/react-auth';
import { useFlag } from '@unleash/proxy-client-react';

const WalletProvider = ({ children, appearance }) => {
  const loginWithWallets = useFlag('loginWithWallets');

  return (
    <PrivyProvider
      appId={import.meta.env.VITE_PRIVY_APP_ID}
      config={{
        loginMethods: Capacitor.isNativePlatform()
          ? ['email', 'sms']
          : loginWithWallets
            ? ['email', 'google', 'apple', 'sms', 'wallet']
            : ['email', 'google', 'apple', 'sms'],
        appearance: {
          walletChainType: 'solana-only',
          walletList: ['detected_wallets'],
          ...appearance,
        },
      }}
    >
      {children}
    </PrivyProvider>
  );
};

export default WalletProvider;
